/* Pipli card — quick-view modal + AJAX add-to-cart (global, once) */
(function () {
  if (window.__ppfQuickView) return;
  window.__ppfQuickView = true;
  var html = document.documentElement;

  function openModal(m) {
    document.querySelectorAll('.ppf-modal.is-open').forEach(function (x) { x.classList.remove('is-open'); x.hidden = true; });
    if (m.parentNode !== document.body) document.body.appendChild(m);
    m.hidden = false; html.style.overflow = 'hidden';
    requestAnimationFrame(function () { m.classList.add('is-open'); });
  }
  function closeModal() {
    document.querySelectorAll('.ppf-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); setTimeout(function () { m.hidden = true; }, 300); });
    html.style.overflow = '';
  }
  function toast(msg, err) {
    var t = document.createElement('div'); t.className = 'ppf-toast' + (err ? ' ppf-toast--err' : ''); t.textContent = msg;
    document.body.appendChild(t); requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 300); }, 2200);
  }
  function updateCount() {
    var u = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(u).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-count-bubble span:first-child').forEach(function (s) { s.textContent = c.item_count; });
      document.querySelectorAll('.cart-count-bubble').forEach(function (b) { b.style.removeProperty('display'); });
    }).catch(function () {});
  }
  function getDrawer() { return document.querySelector('cart-drawer'); }
  function openDrawer(res) {
    var drawer = getDrawer();
    if (drawer && res && res.sections && typeof drawer.renderContents === 'function') { closeModal(); drawer.renderContents(res); return true; }
    return false;
  }
  // Buy Now: open GoKwik express checkout once its (re-rendered) cart button is enabled.
  function fireGokwikCheckout() {
    var n = 0;
    (function go() {
      var b = document.querySelector('cart-drawer .gokwik-checkout button:not([disabled]), .gokwik-checkout button:not([disabled])');
      if (b) { b.click(); return; }
      if (++n <= 16) { setTimeout(go, 200); }
    })();
  }
  function addToCart(id, btn) {
    if (!id || btn.disabled) return;
    var qty = 1, modal = btn.closest('.ppf-modal');
    if (modal) { var qi = modal.querySelector('.ppf-modal__qtyval'); if (qi) qty = Math.max(1, parseInt(qi.value, 10) || 1); }
    var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
    var drawer = getDrawer();
    var body = { items: [{ id: Number(id), quantity: qty }] };
    if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    var u = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
    fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d && (res.d.description || res.d.message) || 'Could not add to cart');
        btn.innerHTML = 'Added &#10003;';
        if (!openDrawer(res.d)) { toast('Added to cart'); updateCount(); }
        if (btn.hasAttribute('data-buynow')) { fireGokwikCheckout(); }
        setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1700);
      })
      .catch(function (err) { btn.innerHTML = label; btn.disabled = false; toast(err.message || 'Error', true); });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) { var inp = qtyBtn.parentNode.querySelector('.ppf-modal__qtyval'); var v = (parseInt(inp.value, 10) || 1) + (qtyBtn.getAttribute('data-qty') === '+' ? 1 : -1); inp.value = Math.max(1, v); return; }
    var openBtn = e.target.closest('[data-qv]');
    if (openBtn) { var m = document.getElementById(openBtn.getAttribute('data-qv')); if (m) { e.preventDefault(); openModal(m); } return; }
    if (e.target.closest('[data-qv-close]')) { e.preventDefault(); closeModal(); return; }
    var add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-add'), add); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.ppf-modal__variant'); if (!sel) return;
    var opt = sel.options[sel.selectedIndex]; var modal = sel.closest('.ppf-modal');
    var addBtn = modal.querySelector('.ppf-modal__add'); if (addBtn) addBtn.setAttribute('data-add', sel.value);
    var priceEl = modal.querySelector('[data-price]'); if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
  });

  // ---- Product card video (lazy hover-play desktop / autoplay-in-view mobile) ----
  // Tie the fade-in class to the video's OWN playback state, not the play() promise
  // (the promise resolves before frames render and can be swallowed, leaving the
  // clip playing but invisible at opacity 0).
  function wireVid(v) {
    if (v.__ppfWired) return; v.__ppfWired = 1;
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    v.addEventListener('pause', function () { v.classList.remove('is-playing'); });
  }
  function playCardVideo(media) {
    var v = media.querySelector('.ppf-card__video');
    if (!v) return false;
    wireVid(v);
    if (!v.src) { v.src = v.getAttribute('data-ppf-vsrc'); }
    var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
    return true;
  }
  function stopCardVideo(media) {
    var v = media && media.querySelector('.ppf-card__video');
    if (!v) return;
    try { v.pause(); } catch (e) {}
  }

  // Hover image gallery — cross-fade through a card's images on hover.
  // Hover-capable pointers only: on touch, taps fire synthetic mouseover and
  // images start cycling without user intent.
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  var galTimers = new WeakMap();

  // Mobile: autoplay ONE card video at a time as it scrolls into view (muted, lazy).
  // Deferred until after load+idle so the first in-view clip never competes with LCP.
  // Skipped on Save-Data / 2G. src attached only when a clip actually becomes active.
  if (!canHover && 'IntersectionObserver' in window) {
    var conn = navigator.connection || {};
    var slow = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
    if (!slow) {
      // Per-card play/pause: a clip plays while it's >=50% visible, pauses otherwise.
      // On a phone viewport at most ~1-2 cards exceed 50% at once, so this is
      // naturally limited without the churn a single-active tracker introduced.
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting && en.intersectionRatio >= 0.5) {
            wireVid(v);
            if (!v.src) { v.src = v.getAttribute('data-ppf-vsrc'); }
            var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
          } else {
            try { v.pause(); } catch (e) {}
          }
        });
      }, { threshold: [0, 0.5] });
      var observeCardVideos = function (root) {
        (root || document).querySelectorAll('.ppf-card__video:not([data-ppf-obs])').forEach(function (v) {
          v.setAttribute('data-ppf-obs', '1'); vio.observe(v);
        });
      };
      var startObs = function () {
        observeCardVideos();
        if ('MutationObserver' in window) { // re-scan when filters/pagination inject new cards
          var rescan; new MutationObserver(function () { clearTimeout(rescan); rescan = setTimeout(observeCardVideos, 300); })
            .observe(document.body, { childList: true, subtree: true });
        }
      };
      var idle = window.requestIdleCallback || function (f) { setTimeout(f, 1200); };
      if (document.readyState === 'complete') { idle(startObs); }
      else { window.addEventListener('load', function () { idle(startObs); }); }
    }
  }

  document.addEventListener('mouseover', function (e) {
    if (!canHover) return;
    var vmedia = e.target.closest('.ppf-card__media[data-ppf-video]');
    if (vmedia && playCardVideo(vmedia)) return; // video preferred over image cycle
    var media = e.target.closest('.ppf-card__media[data-ppf-gallery]');
    if (!media || galTimers.has(media)) return;
    var imgs = media.querySelectorAll('.ppf-card__img');
    if (imgs.length < 2) return;
    var i = 0;
    var t = setInterval(function () {
      imgs[i].classList.remove('is-active');
      i = (i + 1) % imgs.length;
      imgs[i].classList.add('is-active');
    }, 900);
    galTimers.set(media, { t: t, imgs: imgs });
  });
  document.addEventListener('mouseout', function (e) {
    var media = e.target.closest('.ppf-card__media');
    if (!media || (e.relatedTarget && media.contains(e.relatedTarget))) return;
    stopCardVideo(media);
    var g = galTimers.get(media); if (!g) return;
    clearInterval(g.t); galTimers.delete(media);
    g.imgs.forEach(function (im, idx) { if (idx === 0) im.classList.add('is-active'); else im.classList.remove('is-active'); });
  });
})();
